import { useEffect } from 'react';
import type { HydrogenFcfsSettings } from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

export function useHydrogenFcfsSettings(url: string | undefined) {
  const request = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<HydrogenFcfsSettings>({
        ...baseConfig,
        url,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute(url);
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  return request;
}

export type HydrogenFcfsSettingsRequest = ReturnType<
  typeof useHydrogenFcfsSettings
>;
